import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-status-page',
    templateUrl: './status-page.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class StatusPageComponent {
    @Input() statusText!: string | null;
}
